import { render } from "./ValidacionDocumentos.vue?vue&type=template&id=01862237&scoped=true"
import script from "./ValidacionDocumentos.vue?vue&type=script&lang=js"
export * from "./ValidacionDocumentos.vue?vue&type=script&lang=js"

import "./ValidacionDocumentos.vue?vue&type=style&index=0&id=01862237&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01862237"]])

export default __exports__